import copy from "copy-to-clipboard";
import React from "react";
import { useTranslation } from "next-i18next";
import Skeleton from "@/components/skeleton/Skeleton";
import { CopyIcon } from "@/components/RFIcon";
import Toast from "@/components/Toast";

export default function CopyShareCode({ shareCode }: { shareCode: string }) {
	const { t } = useTranslation("common");

	const handleCopy = () => {
		copy(shareCode);
		Toast.success(t("copied"));
	};

	if (!shareCode) {
		return <Skeleton className="w-20 h-5 rounded" />;
	}

	return (
		<div className="inline-flex items-center" onClick={handleCopy}>
			<span className="font-bold">{shareCode}</span>
			<CopyIcon className="w-4 h-4 ml-2" />
		</div>
	);
}
